export enum validationEnums {
  PERMISSIONGROUP_ROOT = "root",
}
